/* eslint-disable import/prefer-default-export */
import makeApiCall from './makeApiCall';

export const getDepartmentFilter = (params) =>
  makeApiCall(`/user/departments/list`, 'GET', params, false);

export const getTeamFilter = (params) => makeApiCall(`/user/teams`, 'POST', params, false);

export const getHeadFilter = (params) => makeApiCall(`/user/heads/list`, 'POST', params);

export const getManagerFilter = (params) => makeApiCall(`/user/managers/list`, 'POST', params);

export const getRepFilter = (params) => makeApiCall(`/user/reps/list`, 'POST', params);

export const getAgendaFilter = (params) => makeApiCall(`/agendas/list`, 'GET', params);

export const getSpecialtyFilter = (params) => makeApiCall(`/user/specialty`, 'GET', params);

export const getGroupFilter = (params) => makeApiCall(`/user/md-group`, 'GET', params);

export const postFilterPRDDashboard = (params) =>
  makeApiCall(`/prd-dashboard/filter-dropdown`, 'POST', params);

export const getGroupOptions = (params) => makeApiCall(`/user/md-group`, 'GET', params);

export const getMDDropdown = (params) => makeApiCall(`/user/doctors/list`, 'POST', params);

export const getProductFilter = (params) => makeApiCall(`/products/list`, 'POST', params);
